import { render, staticRenderFns } from "./UnlinkComponent.vue?vue&type=template&id=4df6a90f&scoped=true"
import script from "./UnlinkComponent.vue?vue&type=script&lang=js"
export * from "./UnlinkComponent.vue?vue&type=script&lang=js"
import style0 from "./UnlinkComponent.vue?vue&type=style&index=0&id=4df6a90f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df6a90f",
  null
  
)

export default component.exports